/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CustomerModel from 'cio/models/customer';

interface PersonProfileNameArgs {
  customer: CustomerModel;
  titleTagName?: string;
  titleClass?: string;
}

export default class PersonProfileName extends Component<PersonProfileNameArgs> {
  get titleTagName() {
    return this.args.titleTagName ?? 'h2';
  }
}
